export default {
  title: "Egram Panchayat",
  data: [
    {
      layout: "ContactUsPage",
      title: "સંપર્ક",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15553.319056429109!2d77.57462069545443!3d12.950738147237534!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x222ebff8a6f5fbea!2sJust%20Signs%20India%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1597755249741!5m2!1sen!2sin",

      data: [],
      inputs: {
        name: {
          label: "તમારું નામ ",
          placeholder: "તમારું નામ ",
        },
        email: {
          label: "ઇમેઇલ ",
          placeholder: "ઇમેઇલ ",
        },
        mobile: {
          label: "મોબાઈલ નંબર ",
          placeholder: "મોબાઈલ નંબર ",
        },
      },
      btnTitle: "સબમિટ ",
      emailTitle: "ઇ-મેઇલ ",

      successMsg: `
      અમારો સંપર્ક કરવા બદલ આભાર. અમારા સહયોગીઓ ટૂંક સમયમાં તમારો સંપર્ક કરશે.`,
    },
  ],
};
